import useJsonLdFaq from '~/composables/useJsonLdFaq'
import useJsonLdVacationRental from '~/composables/useJsonLdVacationRental'
import useJsonLdItemListOfVacationRentals from '~/composables/useJsonLdItemListOfVacationRentals'
import useJsonLdProductWithAggregateRating from '~/composables/useJsonLdProductWithAggregateRating'
import useJsonLdWebsite from '~/composables/useJsonLdWebsite'

export default defineNuxtPlugin((nuxtApp) => {
  // https://nuxt.com/docs/api/advanced/hooks#app-hooks-runtime
  nuxtApp.hook('app:rendered', () => {
    if (import.meta.client) {
      return
    }

    const faqPage = useJsonLdFaq().getAssembledObject()
    const vacationRental = useJsonLdVacationRental().getAssembledObject()
    const itemListOfVacationRentals = useJsonLdItemListOfVacationRentals().getAssembledObject()
    const productWithAggregateRating = useJsonLdProductWithAggregateRating().getAssembledObject()
    const website = useJsonLdWebsite().getAssembledObject()

    if (
      faqPage === null &&
      vacationRental === null &&
      itemListOfVacationRentals === null &&
      productWithAggregateRating === null &&
      website === null
    ) {
      return
    }

    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        ...(faqPage !== null ? [faqPage] : []),
        ...(vacationRental !== null ? [vacationRental] : []),
        ...(itemListOfVacationRentals !== null ? [itemListOfVacationRentals] : []),
        ...(productWithAggregateRating !== null ? [productWithAggregateRating] : []),
        ...(website !== null ? [website] : [])
      ]
    }

    useHead(() => {
      return {
        script: [
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify(jsonLd, null, 2)
          }
        ]
      }
    })
  })
})
